export default __webpack_public_path__ + "static/media/bikeIllustration.bd454ea9.png";